module.exports = "pegasus_template/assets/theme4/medium/7.jpg";